import dayjs from 'dayjs';

export class DeviceItem {
  data: Api.UnitBinding;
  hubLatestVersion: string

  constructor(data: Api.UnitBinding, hubLatestVersion: string) {
    this.data = data;
    this.hubLatestVersion = hubLatestVersion;
  }

  get uploadTime() {
    return this.displayTime(this.data.hub_upload_time);
  }

  get aliveTime() {
    return this.displayTime(this.data.hub_alive_time);
  }

  /**
   * 是否連線 (前端計算時間差)
   */
  get isConnected() {
    const aliveTime = this.data.hub_alive_time;
    if (!aliveTime) {
      return false;
    }
    const last5MinutesTime = dayjs().subtract(5, 'minute');
    return !last5MinutesTime.isAfter(aliveTime);
  }

  get isUpgradable() {
    return this.data.hub_version !== this.hubLatestVersion;
  }

  displayTime(dateTime: string) {
    if (!dateTime) {
      return '--';
    }

    return dayjs(dateTime).format('HH:mm:ss A ,YYYY/MM/DD');
  }
}
